import { keyframes, styled } from "goober";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerRing = styled("span")`
  display: inline-block;
  border-radius: 50%;
  border: 1.5px solid var(--border-alpha);
  border-top-color: var(--text-secondary);
  animation: ${spin} 0.7s linear infinite;
`;

export function Spinner({ size = 16 }: { size?: number }) {
  return <SpinnerRing style={{ width: size, height: size }} />;
}
